import Statistics from "../statistics/Statistics";
import BigNumSave from "./BigNumSave";

export default class StatisticsSave {
    constructor() {        
    }

    /**
     * @param {Statistics} statistics
     * @returns {Object}
     */
    static generateSave(statistics) {
        const saveState = {};

        // play time 
        // start date

        saveState.ore = BigNumSave.save(statistics.totalOre);
        saveState.gold = BigNumSave.save(statistics.totalGold);
        saveState.ruby = BigNumSave.save(statistics.totalRuby);
        saveState.prestige = BigNumSave.save(statistics.totalPrestigePoints);
        saveState.upgradeOre = BigNumSave.save(statistics.upgradeOre);

        saveState.maxDepth = statistics.maxDepth;
        saveState.turns = statistics.totalTurns;

        ///////////////////////////////////////
        // Blocks by type
        ///////////////////////////////////////

        saveState.tiles = BigNumSave.save(statistics.tilesMined);
        saveState.tilesCommon = BigNumSave.save(statistics.tilesMinedCommon);
        saveState.tilesOre = BigNumSave.save(statistics.tilesMinedOre);
        saveState.tilesGold = BigNumSave.save(statistics.tilesMinedGold);
        saveState.tilesRuby = BigNumSave.save(statistics.tilesMinedRuby);
        saveState.tilesUpgrade = BigNumSave.save(statistics.tilesMinedUpgrade);

        ///////////////////////////////////////
        // Blocks by skill
        ///////////////////////////////////////

        saveState.tilesLaser = BigNumSave.save(statistics.tilesMinedLaser);
        saveState.tilesDrill = BigNumSave.save(statistics.tilesMinedDrill);
        saveState.tilesOrbit = BigNumSave.save(statistics.tilesMinedOrbit);
        saveState.tilesFissure = BigNumSave.save(statistics.tilesMinedFissure);
        saveState.tilesLightning = BigNumSave.save(statistics.tilesMinedLightning);
        saveState.tilesMissile = BigNumSave.save(statistics.tilesMinedMissile);

        return saveState;
    }

    /**
     * @param {Statistics} statistics
     * @param {Object} saveState 
     */
    static loadSave(statistics, saveState) {
        if (!saveState) {
            return;
        }

        BigNumSave.load(saveState.ore, statistics.totalOre);
        BigNumSave.load(saveState.gold, statistics.totalGold);
        BigNumSave.load(saveState.ruby, statistics.totalRuby);
        BigNumSave.load(saveState.prestige, statistics.totalPrestigePoints);
        BigNumSave.load(saveState.upgradeOre, statistics.upgradeOre);

        if (saveState.maxDepth) {
            statistics.maxDepth = saveState.maxDepth;
        }

        if (saveState.turns) {
            statistics.totalTurns = saveState.turns;
        }

        ///////////////////////////////////////
        // Blocks by type
        ///////////////////////////////////////

        BigNumSave.load(saveState.tiles, statistics.tilesMined);
        BigNumSave.load(saveState.tilesCommon, statistics.tilesMinedCommon);
        BigNumSave.load(saveState.tilesOre, statistics.tilesMinedOre);
        BigNumSave.load(saveState.tilesGold, statistics.tilesMinedGold);
        BigNumSave.load(saveState.tilesRuby, statistics.tilesMinedRuby);
        BigNumSave.load(saveState.tilesUpgrade, statistics.tilesMinedUpgrade);

        ///////////////////////////////////////
        // Blocks by skill
        ///////////////////////////////////////

        BigNumSave.load(saveState.tilesLaser, statistics.tilesMinedLaser);
        BigNumSave.load(saveState.tilesDrill, statistics.tilesMinedDrill);
        BigNumSave.load(saveState.tilesOrbit, statistics.tilesMinedOrbit);
        BigNumSave.load(saveState.tilesFissure, statistics.tilesMinedFissure);
        BigNumSave.load(saveState.tilesLightning, statistics.tilesMinedLightning);
        BigNumSave.load(saveState.tilesMissile, statistics.tilesMinedMissile);
    }

}